<template>
  <div>
    <!-- articles -->
    <section class="articles" id="articles" style="overflow: hidden;">
      <div class="container">
        <h3 class="customHeader h1">Articles</h3>
        <!-- Section description -->
        <p class="text-center w-responsive mx-auto mb-5">
          Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
          dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
          proident, sunt in culpa qui officia deserunt mollit anim id est
          laborum.
          {{ articles.length }}
          {{ active }}
        </p>
        <div class="art-container">
          <!-- spinner -->
          <div
            class="text-center spinner"
            v-if="!active"
            style="color: #000098;"
          >
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div
            class="row wow slideInLeft mb-4"
            v-for="article in articles"
            :key="article['.key']"
            v-else
          >
            <div class="col-lg-5">
              <div class="view overlay rounded z-depth-2 mb-lg-0 mb-4">
                <img class="img-fluid" :src="article.image" alt="miniature" />
                <a
                  ><div
                    class="mask rgba-white-slight waves-effect waves-light"
                  ></div
                ></a>
              </div>
            </div>
            <div class="col-lg-7">
              <a href="#!" class="indigo-text">
                <h6 class="font-weight-bold mb-3">
                  <i class="fas fa-stethoscope pr-2"></i>Santé
                </h6>
              </a>
              <h3 class="font-weight-bold mb-3">{{ article.titre }}</h3>
              <p>{{ article.resume }}</p>
              <p>by {{ article.author }}, {{ article.pubDate }}</p>
              <router-link
                class="btn btn-indigo btn-md"
                :to="'article/' + article['.key']"
                >Read more</router-link
              >
            </div>
          </div>
          <hr class="my-5" />
          <!-- spinner -->
        </div>
      </div>
    </section>
    <nav
      id="pagination"
      v-if="active"
      aria-label="Page navigation example disabled"
    >
      <ul class="pagination justify-content-center">
        <li class="page-item disabled">
          <a class="page-link" href="" tabindex="-1" aria-disabled="true"
            >Previous</a
          >
        </li>
        <li class="page-item disabled"><a class="page-link" href="">1</a></li>
        <li class="page-item disabled"><a class="page-link" href="">2</a></li>
        <li class="page-item disabled"><a class="page-link" href="">3</a></li>
        <li class="page-item disabled">
          <a class="page-link" href="">Next</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { db } from "@/firebase";
export default {
  data() {
    return {
      articles: [],
      active: false
    };
  },
  firebase: {
    articles: db
      .ref()
      .child("articles")
      .orderByChild("arId")
      .limitToLast(3)
  },
  updated() {
    this.articles.length > 0 ? (this.active = true) : (this.active = false);
  }
};
</script>


<style lang="scss">
/* start article  */
.articles {
  height: auto !important;
  overflow: hidden;
  margin-bottom: 20px;
}
.art-container {
  word-break: break-all;
}
.art-container img {
  height: 250px;
  width: 100%;
}
</style>